import * as React from 'react'

import { useHandlers } from './useHandlers'
import type { Requirement } from '../../../typings'
import { ClosingReqLink } from './ClosingReqLink.styled'

type Props = {
  count: number
  countLoading: boolean
  testId: string
  linkText: string
  disabled?: boolean
  linkClick?: () => void
  requirement: Requirement
}

export function ClosingRequirementLink(props: Props) {
  const {
    count,
    testId,
    linkText,
    disabled,
    linkClick,
    requirement,
    countLoading,
  } = props

  const label = countLoading ? linkText : `${linkText} (${count})`

  const { onClick } = useHandlers({
    disabled,
    linkClick,
    requirement,
  })

  return (
    <ClosingReqLink onClick={onClick} disabled={disabled} data-test-id={testId}>
      {label}
    </ClosingReqLink>
  )
}
